import React from "react";

import {
  Delete as DeleteIcon,
  FileCopy as FileCopyIcon,
  Visibility as VisibilityIcon,
} from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

export interface IAction {
  onClick: () => void;
  label: string;
  icon: JSX.Element;
}

function Action(props: IAction): JSX.Element {
  const { onClick, label, icon } = props;
  return (
    <div className="actions-dropdown-content" onClick={onClick}>
      <div className="actions-dropdown-icon">{icon}</div>
      <div className="actions-dropdown-label">{label}</div>
    </div>
  );
}

interface IDropdownSeasonActions {
  index: number;
  setDeleteSeasonIndex: (index: number) => void;
  onPreview: () => void;
  onCopyUuid: () => void;
}

function DropdownSeasonActions({
  index,
  setDeleteSeasonIndex,
  onPreview,
  onCopyUuid,
}: IDropdownSeasonActions): JSX.Element {
  const { t } = useTranslation("editor-series");
  return (
    <React.Fragment>
      <Action
        icon={<VisibilityIcon />}
        label={t("preview")}
        onClick={onPreview}
      />
      <Action
        icon={<FileCopyIcon />}
        label={t("copyUuid")}
        onClick={onCopyUuid}
      />
      <Action
        icon={<DeleteIcon />}
        label={t("delete")}
        onClick={(): void => setDeleteSeasonIndex(index)}
      />
    </React.Fragment>
  );
}

export default DropdownSeasonActions;
